import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

Vue.use(Vuetify)

const theme = {
  primary: '#0066FF',
  pOrrange: '#FF8C21',
  secondary: '#696969',
  accent: '#E91E63',
  info: '#2196F3',
}
export default new Vuetify({
  rtl: true,
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
